import axios from 'axios';
import {integrationUrl} from '@/api/base';

const IntegrationUtils = {

    getRestrictions() {
        return axios.get(integrationUrl + `request.php?id=` + JSON.parse(localStorage.getItem('user')).id);
    }

    // getRestrictions(id) {
    //     return axios.get(integrationUrl + `request.php`,{
    //         params: {
    //             id: id
    //         }
    //     });
    // }

};

export default IntegrationUtils;
